const info = [
  {
    label: 'Teléfono / WhatsApp',
    value: '(+51) 965 194 210',
    href: 'tel:+51965194210',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A15 15 0 013 6a2 2 0 012-2z"/>
    ),
  },
  {
    label: 'Correo electrónico',
    value: 'info@ibrperu.com',
    href: 'mailto:info@ibrperu.com',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
    ),
  },
  {
    label: 'Horario de atención',
    value: 'Lun – Sáb, 9:00 am – 6:00 pm',
    href: null,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
    ),
  },
  {
    label: 'Ubicación',
    value: 'Baños del Inca · Cajamarca · Perú',
    href: null,
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
    ),
  },
];

export default function Contact() {
  return (
    <section id="contacto" className="px-8 md:px-16 py-20 md:py-12 xl:py-20">
      {/* Header — centered */}
      <div className="text-center mb-12 md:mb-7 xl:mb-12">
        <p className="text-xs tracking-[.28em] text-gray-400 uppercase font-medium mb-3">Contacto</p>
        <h2 className="text-3xl md:text-3xl xl:text-4xl font-bold text-black leading-tight">
          Hablemos de tu<br/>
          <span className="font-light italic">próxima inversión</span>
        </h2>
      </div>

      {/* Cards — centered, max width */}
      <div className="max-w-lg mx-auto flex flex-col gap-3 md:gap-2 xl:gap-3">
        {info.map((item) => (
          <div key={item.label}
            className="flex items-center gap-4 bg-white rounded-2xl px-5 py-4 md:py-3 xl:py-4 hover:shadow-md transition-all duration-300 hover:-translate-y-0.5 group">
            <div className="w-10 h-10 md:w-8 md:h-8 xl:w-10 xl:h-10 rounded-xl bg-gray-100 flex items-center justify-center flex-shrink-0 group-hover:bg-black transition-colors duration-300">
              <svg className="w-4 h-4 md:w-3.5 md:h-3.5 xl:w-4 xl:h-4 text-gray-600 group-hover:text-white transition-colors duration-300"
                fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                {item.icon}
              </svg>
            </div>
            <div>
              <p className="text-[10px] tracking-[.2em] uppercase font-semibold text-gray-400 mb-0.5">{item.label}</p>
              {item.href ? (
                <a href={item.href}
                  target={item.href.startsWith('http') ? '_blank' : undefined}
                  rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="text-sm md:text-xs xl:text-sm font-medium text-black hover:text-gray-600 transition-colors">
                  {item.value}
                </a>
              ) : (
                <p className="text-sm md:text-xs xl:text-sm font-medium text-black">{item.value}</p>
              )}
            </div>
          </div>
        ))}

        {/* WhatsApp CTA */}
        <a
          href="https://wa.me/51965194210"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2.5 bg-[#25D366] text-white text-sm font-semibold
            rounded-2xl p-4 md:p-3 xl:p-4 hover:bg-[#20bc5a] hover:shadow-lg hover:-translate-y-0.5
            transition-all duration-300 active:scale-95 mt-1"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Escribir por WhatsApp
        </a>
      </div>
    </section>
  );
}

